import React from "react";
import isEmail from "validator/es/lib/isEmail";
import AlertComponent from "../../_UI/Components/Alerts/AlertComponent";
import { Col, FormFeedback, Row } from "reactstrap";
import { LoadingSpinnerButton } from "../../_UI/Components/PathwayButtons";
import { PathwayCheckbox, PathwayInput, PathwayLabel } from "../../_UI/StyledComponents/PathwayForm";

class RegistrationComponent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            email: "",
            password: "",
            password2: "",
            submitted: false,
            acceptTos: false,
            acceptDpa: false,
            emailError: "",
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleEmailBlur = this.handleEmailBlur.bind(this);
    }

    handleChange(e) {
        const { name } = e.target;
        const value = e.target.type === "checkbox" ? e.target.checked : e.target.value;

        this.setState({ [name]: value });
        if (name === "email") {
            this.setState({ emailError: "" });
        }
    }

    handleEmailBlur() {
        if (this.state.email) {
            const trimmed = this.state.email.trim();
            if (trimmed.includes(" ")) {
                this.setState({ email: trimmed, emailError: "E-Mail-Adresse enthält ungültige Leerzeichen" });
            } else if (trimmed && !isEmail(trimmed)) {
                this.setState({ email: trimmed, emailError: "Ungültige E-Mail-Adresse" });
            } else {
                this.setState({ email: trimmed, emailError: "" });
            }
        }
    }

    render() {
        const { registration } = this.props;
        const { email, password, password2, submitted, acceptTos, acceptDpa, emailError } = this.state;

        return (
            <div>
                <AlertComponent
                    errorMessages={registration.errorMessage}
                    warningMessages={registration.warningMessage}
                />
                <div className="input-group" style={{ marginTop: "1em", marginBottom: "1em" }}>
                    <div className="input-group-append">
                        <span className="input-group-text">
                            <i className="icon-user"></i>
                        </span>
                    </div>
                    <PathwayInput
                        type="text"
                        invalid={((submitted && !email) || !!emailError)}
                        placeholder="E-Mail"
                        name="email"
                        value={email}
                        onChange={this.handleChange}
                        onBlur={this.handleEmailBlur}
                    />
                    {submitted && !email && <FormFeedback>Bitte gib eine E-Mail Adresse ein</FormFeedback>}
                    {emailError && <FormFeedback className="d-block">{emailError}</FormFeedback>}
                </div>
                <div className="input-group mb-4">
                    <div className="input-group-append">
                        <span className="input-group-text">
                            <i className="icon-lock"></i>
                        </span>
                    </div>
                    <PathwayInput
                        type="password"
                        invalid={(submitted && !password)}
                        placeholder="Passwort"
                        name="password"
                        value={password}
                        onChange={this.handleChange}
                    />
                    {submitted && !password && <FormFeedback>Bitte gib das Passwort ein</FormFeedback>}
                </div>
                <div className="input-group mb-4">
                    <div className="input-group-append">
                        <span className="input-group-text">
                            <i className="icon-lock"></i>
                        </span>
                    </div>
                    <PathwayInput
                        type="password"
                        invalid={(submitted && !password2)}
                        placeholder="Passwort wiederholen"
                        name="password2"
                        value={password2}
                        onChange={this.handleChange}
                    />
                    {submitted && !password2 && <FormFeedback>Bitte wiederhole das Passwort</FormFeedback>}
                </div>
                <br />
                <div className="checkbox">
                    <PathwayCheckbox
                        id="acceptTos"
                        name="acceptTos"
                        checked={acceptTos}
                        onChange={this.handleChange}
                    />
                    <PathwayLabel htmlFor="acceptTos">
                        Ich stimme der{" "}
                        <a
                            href={
                                "https://app.pathway-solutions.de/Nutzungsvereinbarung_Platform.pdf"
                            }
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Nutzungsvereinbarung
                        </a>{" "}
                        in der derzeit gültigen Fassung zu.
                    </PathwayLabel>
                </div>
                <div className="checkbox">
                    <PathwayCheckbox
                        id="acceptDpa"
                        name="acceptDpa"
                        checked={acceptDpa}
                        onChange={this.handleChange}
                    />
                    <PathwayLabel htmlFor="acceptDpa">
                        Ich stimme dem Vertrag zur{" "}
                        <a
                            href={"https://app.pathway-solutions.de/AVV_Platform.pdf"}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Auftragsverarbeitung
                        </a>{" "}
                        zu.
                    </PathwayLabel>
                </div>
                <br />
                <Row>
                    <Col xs="12">
                        <LoadingSpinnerButton
                            loading={this.props.loading}
                            disabled={this.props.loading}
                            onClick={(e) =>
                                this.props.register(
                                    e,
                                    this.state.email?.trim(),
                                    this.state.password,
                                    this.state.password2,
                                    acceptTos,
                                    acceptDpa
                                )
                            }
                        >
                            Weiter{" "}
                        </LoadingSpinnerButton>
                    </Col>
                </Row>
                <Row>
                    <Col xs="12">
                        <br />
                        {submitted && registration && (
                            <AlertComponent
                                errorMessages={registration.errorMessage}
                                warningMessages={registration.warningMessages}
                            />
                        )}
                    </Col>
                </Row>
            </div>
        );
    }
}

export default RegistrationComponent;
